import { useEffect, useState } from 'react'
import { isApp } from '../utils/platform'
import {
  BRIDGE_POLL_MS,
  BRIDGE_WAIT_MS,
  GRACE_MS,
  SharedPhotosSupport,
  bridge,
  hasSharedPhotos,
  injectionDone,
} from '../utils/sharedPhotosBridge'

/**
 * 이 앱이 '공유받은 사진'을 줄 수 있는 빌드인가.
 *
 * 입구를 그릴지 말지 정하는 데 쓴다. **모르는 동안에는 숨긴다** —
 * 잠깐 늦게 나타나는 버튼은 아무도 다치지 않지만, 눌렀더니 막다른 화면이
 * 나오는 버튼은 1.0.43 이 심사를 통과할 때까지 모든 구버전 사용자가 겪는다.
 */
export const useSharedPhotosSupport = (): SharedPhotosSupport => {
  const [support, setSupport] = useState<SharedPhotosSupport>('checking')

  useEffect(() => {
    // 웹 브라우저에는 통로 자체가 없다. 기다릴 것도 없다.
    if (!isApp()) {
      setSupport('unsupported')
      return
    }

    let timer: number | null = null
    let doneSeen: number | null = null
    let settled = false
    const started = Date.now()

    const stop = () => {
      settled = true
      if (timer !== null) window.clearInterval(timer)
      timer = null
    }

    const look = () => {
      const b = bridge()
      if (hasSharedPhotos(b)) {
        stop()
        setSupport('ready')
        return
      }
      const now = Date.now()
      if (injectionDone(b)) {
        if (doneSeen === null) doneSeen = now
        if (now - doneSeen >= GRACE_MS) {
          stop()
          setSupport('unsupported') // 주입은 끝났는데 없다 = 옛 빌드
          return
        }
      }
      if (now - started > BRIDGE_WAIT_MS) {
        stop()
        setSupport('unsupported')
      }
    }

    look()
    if (!settled) timer = window.setInterval(look, BRIDGE_POLL_MS)
    return stop
  }, [])

  return support
}

export default useSharedPhotosSupport
